"use strict";

export const title: string = "Scott @ Linglesmith";
